import showdown from 'showdown';

showdown.setOption('disableForced4SpacesIndentedSublists', true);
showdown.setOption('simpleLineBreaks', true);
showdown.setOption('tables', true);

const converter = new showdown.Converter();

export default {
  name: 'GcCopy',
  computed: {
    className() {
      return 'gc__copy';
    },
    themeClassName() {
      return `${this.className}--${this.theme}`;
    },
    textAlignClassName() {
      return `${this.className}--${this.textAlign}`;
    },
    textSizeClassName() {
      return `${this.className}--${this.textSize}`;
    },
  },
  methods: {
    markdownify(content) {
      return converter.makeHtml(content);
    },
  },
  props: {
    content: {
      type: String,
      default: '',
    },
    textAlign: {
      type: String,
      default: 'left',
    },
    textSize: {
      type: String,
      default: 'primary',
    },
    theme: {
      type: String,
      default: 'light',
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
